// $(window).scroll(function(){
//   if($(window).scrollTop() >= 100){
//     $("div#shopify-section-product-sticky").addClass("product-sticky-fix");
//   }else{
//     $("div#shopify-section-product-sticky").removeClass("product-sticky-fix");
//   }
// });

// ===================== Mobile Header Close =====================
$(document).ready(function(){
  $(".custom_header_close").click(function(){
    $("body").removeClass("show-mobile-nav");
  });
  $(".mobile_overlay").click(function(){
    $("body").removeClass("show-mobile-nav");
  });
  
  // Desktop Menu
  // $(".nav-item").click(function(){
  //     $(this).find(".sub-nav.parent-sub-nav").slideToggle();
  // });
});

// ===================== Product sticky =====================
$('.product-sticky-right button').on('click', function(){
  $('span.payment-and-quantity__add .product-add').trigger('click');
});

$(window).scroll(function(){ 
  if ($(window).scrollTop() >= 300) {
    $('.announcement-header').addClass('fixed-header');
    var height =  $('.announcement-header').height();
    $('body').css('padding-top',height+'px');
    $('body').addClass('visible-title');
  }
  else {
    $('.announcement-header').removeClass('fixed-header');
    $('body').removeClass('visible-title');
    $('body').css('padding-top','0px');
  }
});

$('.cart-drawer-overlay').on('click', function() {
    if ($('body').hasClass('show-cart-summary')) {
        $('body').removeClass('show-cart-summary');
      $('html').removeClass('show-cart-drawer');
    }
});

// ===================== Loader =====================

$(window).on('load', function() {       
  $("div#loader-wrapper").addClass("loaded").fadeOut(1500);
});

//  cookie-popup
$(document).ready(function(){
  $('#popin_tc_privacy_button_3, .enregistrer-btn').click(function(){
    localStorage.setItem('cookies',false);
    $(this).parents('.cookies-popup').addClass('hidden');
  });
  $('#popin_tc_privacy_button_2').click(function(){
    localStorage.setItem('cookies',true);
    $(this).parents('.cookies-popup').find('.cookies-popup-container').removeClass('active');
    $(this).parents('.cookies-popup').find('.reset-cookies-popup').addClass('active');
  });

  setTimeout(function(){
    if(localStorage.getItem('cookies') == 'false'){

      $('.cookies-popup').addClass('hidden');
      $('body').addClass('cookies-popup-open');
    }else{
      $('.cookies-popup').removeClass('hidden');
      $('body').removeClass('cookies-popup-open');
    }
  },3200);

  $('.reset-btn-close').click(function(){
    $(this).parents('.cookies-popup-container').removeClass('active');
    $(this).parents('.cookies-popup').find('.tc-privacy-wrapper').addClass('active');
  });

  $('.btn-yes').click(function(){
    $(this).parents('.btn-toggle').addClass('btn-toggle-on').attr('aria-checked', true);
  });
  $('.btn-no').click(function(){
    $(this).parents('.btn-toggle').removeClass('btn-toggle-on').attr('aria-checked', false);
  });
});

// =======================Slider Home=============================
$('.slider_left_part').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  arrows: false, 
  dots: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: false,
      }
    }    
  ]
});

$('#featuredblog').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1, 
  arrows: false, 
  autoplay: true,
  autoplaySpeed: 5000,
  adaptiveHeight: true,
  dots: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         adaptiveHeight: true,
         arrows: false
      }
    }    
  ]
});

$('.slider_left_part').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,  
  arrows: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    },
    {
      breakpoint: 376,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
      }
    }
  ]
});

// Accordion Design js
if ($(".accordion-box").length) {
    $(".accordion-box").on("click", ".acc-btn", function () {
        var outerBox = $(this).parents(".accordion-box");
        var target = $(this).parents(".accordion");
        if ($(this).next(".acc-content").is(":visible")) {
            //return false;
            $(this).removeClass("active");
            $(this).next(".acc-content").slideUp(300);
            $(outerBox).children(".accordion").removeClass("active-block");
        } else {
            $(outerBox).find(".accordion .acc-btn").removeClass("active");
            $(this).addClass("active");
            $(outerBox).children(".accordion").removeClass("active-block");
            $(outerBox).find(".accordion").children(".acc-content").slideUp(300);
            target.addClass("active-block");
            $(this).next(".acc-content").slideDown(300);
        }
    });
}

// =============================== Footer top Section ==================
// $('.index-section .index-section-wrapper').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,  
//   arrows: false,
//   prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
//   nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: false,
//         dots: false,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         arrows: true
//       }
//     },
//     {
//       breakpoint: 376,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: true
//       }
//     }
//   ]
// });

// FAQ

// $('.queans__main .question').click(function(){
//   $('.queans__main').not($(this).parent()).removeClass('active');
//   $(this).parent().toggleClass('active');
//   $('.answer').not($(this).siblings()).slideUp();
//   $(this).siblings().slideToggle();
// });


$(document).ready(function(){
if($(window).width() < 1199){
      $('#slider_a').slick({
    slidesToShow: 3,
  autoplay: true,
     dots: false,
  speed: 8000,
        easing:'linear',
        autoplaySpeed: 5, 
    arrows:false,
     infinite: true,
        pauseOnHover: false,
        cssEase: 'linear',
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
            }
          }
          
  ]
    });
}
});

// $(document).resize(function(){
// if($(window).width() < 992){
//     $('#slider_a').slick({
//     slidesToShow: 3,
//   speed: 3000,
//   autoplay: true,
//      dots: false,
//     arrows:false,
//     autoplaySpeed: 0,
//      infinite: true,
//       pauseOnHover: false,
//       cssEase: 'linear',
//       responsive: [
//           {
//             breakpoint: 768,
//             settings: {
//               slidesToShow: 2
//             },
//           },
//           {
//             breakpoint: 575,
//             settings: {
//               slidesToShow: 1,
//             }
//           }
          
//   ]
//     });
// }
// });



//-----------------------colle-page-slider 
$('.coll-page-slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1, 
  arrows: true, 
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',      
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
          arrows: true, 
      }
    }, 
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
          arrows: true, 
      }
    }, 
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows: true, 
      }
    }    
  ]
});


$('.pop_video_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1, 
  arrows: true, 
  dots: false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>'  

});

// ------------------cart page tab

$(function() {
  $('.cart-delivery-arthur-box .tabs-nav a').click(function() {


    $('.cart-delivery-arthur-box .tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    
    let currentTab = $(this).attr('href');
    $('.cart-delivery-arthur-box .tabs-content div').hide();
    $(currentTab).show();

    return false;
  });
  $(window).scroll(function() {
    if ($(window).width() <= 767) {
        var scrollTop = $(this).scrollTop();
        var documentHeight = $(document).height();
        var windowHeight = $(window).height();
        var scrollBottom = documentHeight - (scrollTop + windowHeight);

        if (scrollTop > 100 && scrollBottom > 500) {
            $('.product_sticky_btn').addClass('fixed');
        } else {
            $('.product_sticky_btn').removeClass('fixed');
        }
    } else {
        $('.product_sticky_btn').removeClass('fixed'); // Ensure class is removed if window width is more than 767
    }
  });
  
  

});







// jQuery(".instant_saving_cart .cart-btn-drawer").click(function(e) {
//     e.preventDefault();
//     alert("addd");  
//     var val = jQuery(this).parents(".instant_saving_cart .product_related_cart").find('input[name="id"]').val();
//     console.log(val);
//     var qty = jQuery(this).parents(".instant_saving_cart .product_related_cart").find('input[name="quantity"]').val();
//     console.log(qty);
//     // var qty = 1;
//     jQuery.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {"id":val,"quantity":qty},
//         dataType: 'json',
//         success: function(data) { 
//           // var cartItemCount = data.item_count;
//           // console.log(cartItemCount);
//           //updateCartDrawer();
//           jQuery.getJSON('/cart.js', function(cart) {
//              // now have access to Shopify cart object
//             var cart_count = cart.item_count;
//              //alert('There are now ' + cart.item_count + ' items in the cart.');
//               $(".cart-summary__item-list-header__count").text('(' + cart_count + ')');
//           } );
//           console.log('Product added');
//         },
//         error: function() {
//           console.log('error');
//         }
//       });
//   });

// $(document).ready(function() {
//   $('.vid-main').click(function(){
//     $(this).find('.popup-overlay').addClass('show');
//   });

//   $('.popup-close').click(function(){
//     $(this).parents('.popup-overlay').removeClass('show');
//   });
// });

$(document).ready(function() {
  // Open the popup
  $('.pop_main_col').click(function(){
  $(this).parent('.vid-main').find('.popup-overlayy').addClass('pop_show');
  $('body').addClass('pop_open');
});

$('.popup-closee').click(function(){
 $('.popup-overlayy').removeClass('pop_show');
  $('body').removeClass('pop_open');
});

 $(".cart-summary__inner .beside-svg").text("Accueil") 
});



$('.faq-head_pro').on('click', function() {
  if($(this).hasClass('active')) {
  $(this).siblings('.faq-content_pro').slideUp();
  $(this).removeClass('active');
  }
  else {
  $('.faq-content_pro').slideUp();
  $('.faq-head_pro').removeClass('active');
  $(this).siblings('.faq-content_pro').slideToggle();
  $(this).toggleClass('active');
  }
  });

//======================

document.addEventListener('DOMContentLoaded', function() {
  const filterButtons = document.querySelectorAll('.filter_nav_link');
  const elements = document.querySelectorAll('.element-item');
  const announcementHeader = document.querySelector('.announcement-header');

  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove 'is-checked' class from all buttons
      filterButtons.forEach(btn => btn.classList.remove('is-checked'));
      // Add 'is-checked' class to the clicked button
      this.classList.add('is-checked');
      
      // Get the filter value from the clicked button
      const filterValue = this.getAttribute('data-filter');
      
      // Redirect to the matching class element
      if (filterValue === '*') {
        window.location.hash = '';
      } else {
        const targetElement = document.querySelector(filterValue);
        if (targetElement) {
          // Calculate the offset position based on announcement-header height
          if (window.innerWidth < 575) {
            var offset = announcementHeader ? announcementHeader.offsetHeight + 90 : 0;
          } else if (window.innerWidth < 992) {
            var offset = announcementHeader ? announcementHeader.offsetHeight + 70 : 0;
          }else{
            var offset = announcementHeader ? announcementHeader.offsetHeight + 35 : 0;
          }
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
          window.location.hash = filterValue;
        }
      }
    });
  });
});



$(document).ready(function(){
  if($('#product-bundle-steps').length > 0){
    $('#product-bundle-steps .product-bundle-step').click(function (e) {
      e.preventDefault();
      $(this).addClass('active');
      $(this).siblings('.product-bundle-step').removeClass('active');
      var data_tab = $(this).data('bundle-tab-target');
      $('.product-bundle-products .product-bundle-products-row[data-bundle-tab="'+data_tab+'"]').removeClass('hidden').siblings('.product-bundle-products-row').addClass('hidden');
      $("#bundle-searchbar").val("").trigger("keyup");
    });

    function change_bundle_steps(current_step, complete){
      if (complete == true) {
        $('#product-bundle-steps .product-bundle-step[data-bundle-tab-target="'+current_step+'"]').addClass('success').next('.product-bundle-step').click();
      }else{
        $('#product-bundle-steps .product-bundle-step[data-bundle-tab-target="'+current_step+'"]').removeClass('success');
      }
      if($('#product-bundle-steps .product-bundle-step').length == $('#product-bundle-steps .product-bundle-step.success').length){
        $('.product-bundle-atc .product-form__buttons').removeClass('hidden');
        $(".product-bundle-products").find(".product-bundle-checkbox input:checked").each(function(i,j) {
          i = i+1;
          $(this).attr("name", "properties[ITEM" + i + "]");
        });
      }else{
        $('.product-bundle-atc .product-form__buttons').addClass('hidden');
      }
    }
    
    $('.product-bundle-products .product-bundle-card .product-bundle-checkbox input[type="checkbox"]').on('change',function () {
      var product_limit = $(this).parents('.product-bundle-products-row').data('bundle-product');
      var checked_values = $(this).parents('.product-bundle-products-row').find('.product-bundle-checkbox input[type="checkbox"]:checked').length;
      var tab = $(this).parents('.product-bundle-products-row').data('bundle-tab');
      if(product_limit == checked_values){
        $(this).parents('.product-bundle-item').siblings('.product-bundle-item').find('.product-bundle-checkbox input[type="checkbox"]:not(:checked)').attr('disabled','disabled');
        change_bundle_steps(tab, true);
      }else{
        $(this).parents('.product-bundle-item').siblings('.product-bundle-item').find('.product-bundle-checkbox input[type="checkbox"]:not(:checked)').removeAttr('disabled');
        change_bundle_steps(tab, false);
      }
    });

    $("#bundle-searchbar").on("keyup", function() {
      var value = $(this).val().toLowerCase();
      $(".product-bundle-products-row:not(.hidden) .product-bundle-item").filter(function() {
        $(this).toggle($(this).find(".product-bundle-card-title .card_title").text().toLowerCase().indexOf(value) > -1)
      })
    });
    
    $("#bundle-search-clear").click(function(e) {
      $("#bundle-searchbar").val("").trigger("keyup");
    });
    
  }
  
  if($('.product-video-showcase').length > 0){

    $(window).on('load', function() {
      // Get front videos
      $('#product-video-showcase-slider .product-video-showcase-block').each(function() {
        let video_url = $(this).find('.video-block').data('video');
        let video_poster = $(this).find('.video-block').data('video-poster');
        $(this).find('.video-block').html(`<video playsinline="true" autoplay="autoplay" muted="muted" loop="loop" preload="auto" poster="${video_poster}"><source src="${video_url}" type="video/mp4"><img src="${video_poster}"></video>`);
      });

      // Get Model Slider products
      var model_product_length = $('#product-video-showcase-model .product-video-showcase-model-block').length;
      $('#product-video-showcase-model .product-video-showcase-model-block').each(function(i, item) {
        let block = $(this);
        let producturl = `/products/${$(this).data('product')}?view=video-showcase-model`;
        fetch(producturl)
        .then(responseText => responseText.text())
        .then((responseText)=>{
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          $(block).html($(html).find('.product-video-showcase-model-block').html());
          if((model_product_length - 1) == i){
            // product model slider
            var product_video_showcase_model = new Swiper("#product-video-showcase-model-slider", {
              centeredSlides: true,
              slidesPerView: 1,
              spaceBetween: 0,
              direction: 'vertical',
              navigation: {
                nextEl: $('#product-video-showcase-model').find('.swiper-button-next')[0],
                prevEl: $('#product-video-showcase-model').find('.swiper-button-prev')[0],
              },
              on: {
                slideChange: function () {
                  var currentSlide = this.slides[this.realIndex];            
                  $(currentSlide).siblings().each(function () {
                    $(this).find('video')[0].pause();
                    $(this).find('video')[0].currentTime = 0;
                  });
      
                  $(currentSlide).find('video')[0].play();
                  if($(currentSlide).find('.video-sound-button').hasClass('play-sound')){
                    $(currentSlide).find('video')[0].muted = false;
                  }else{
                    $(currentSlide).find('video')[0].muted = true;
                  }
                },
                click() {
                  product_video_showcase_model.slideTo(this.clickedIndex);    
                },
              },
              breakpoints: {
                750: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                  effect: "coverflow",
                  allowTouchMove: false,
                  coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 50,
                    modifier: 0,
                    slideShadows: true,
                  },
                  direction: 'horizontal',
                },
                501: {
                  slidesPerView: 'auto',
                  spaceBetween: 20,
                  direction: 'horizontal',
                }
              }
            });
          }
        });
      });
      

      // product showcase slider
      var product_video_showcase = new Swiper('#product-video-showcase-slider', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '#product-video-showcase-slider .swiper-button-next',
          prevEl: '#product-video-showcase-slider .swiper-button-prev',
        },
        breakpoints: {
          750: {
            spaceBetween: 20
          },
        }
      });

      // Open showcase model
      $('#product-video-showcase-slider .product-video-showcase-block').on('click', function() {
        var clickedIndex = $(this).data('index');
        $('#product-video-showcase-model').fadeIn();
        $('body').addClass('overflow-hidden');
        if($('#product-video-showcase-model-slider')[0].swiper){
          $('#product-video-showcase-model-slider')[0].swiper.update();
        }
        $('#product-video-showcase-model-slider')[0].swiper.slideTo(clickedIndex - 1, 0);
        if(clickedIndex == 1){
          $('#product-video-showcase-model-slider .product-video-showcase-model-block video')[0].play();
        }
      });

      // Close showcase model
      $('#product-video-showcase-model-close').on('click', function(e) {
        e.preventDefault();
        $('#product-video-showcase-model').fadeOut();
        $('body').removeClass('overflow-hidden');
        $('#product-video-showcase-model-slider .product-video-showcase-model-block .video-sound-button').removeClass('play-sound');
        $('#product-video-showcase-model-slider .product-video-showcase-model-block').each(function () {
          $(this).find('video')[0].muted = true;
        });
      });

      // Play Off video sound
      $(document).on('click', '.video-sound-button',function () {
        $('#product-video-showcase-model-slider .product-video-showcase-model-block .video-sound-button').toggleClass('play-sound');
        if($(this).hasClass('play-sound')){
          $(this).siblings('video')[0].muted = false;
        }else{
          $(this).siblings('video')[0].muted = true;
        }
      });

      // Read more button
      $(document).on('click', '#product-video-showcase-model .show-case-read-more-btn', function (e) {
        e.preventDefault();
        $(this).parents('.description-block').toggleClass('active');
      });

      // Cart Button
      $(document).on('click', '#product-video-showcase-model .show-case-cart-btn', function (e) {
        e.preventDefault();
        $('cart-drawer').trigger('open')
      });

      // Model product variant chnage
      $(document).on('change', '#product-video-showcase-model .show-case-variant-opt input[type="radio"]', function () {
        var block = $(this).parents('.product-showcase-info');
        var url = $(this).parents('.product-showcase-info').data('url');
        var val = $(block).find('.show-case-variants input[type="radio"]:checked').map(function () {return $(this).data('option-value-id');}).get();
        var producturl = `${url}?option_values=${val.join(',')}&view=video-showcase-model`;
        fetch(producturl)
        .then(responseText => responseText.text())
        .then((responseText)=>{
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          $(block).find('.show-case-variants').html($(html).find('.show-case-variants').html());
          $(block).find('.product-showcase-price').html($(html).find('.product-showcase-price').html())
          $(block).find('product-form .product-variant-id').val($(html).find('product-form .product-variant-id').val())
          console.log($(html).find('product-form .product-showcase_submit'));
          $(block).find('product-form .product-showcase_submit').replaceWith($(html).find('product-form .product-showcase_submit'));
        });
      });
    });
  }
});
